var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 283,
    height: 224,
    viewBox: "0 0 283 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.22 .85)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9F1FF",
    fillRule: "nonzero",
    d: "M250.168037,199.118202 C273.592037,177.661202 292.360037,150.495202 277.397037,120.559202 C262.435037,90.623202 233.406037,92.808202 215.629037,65.421202 C193.408037,31.187302 205.947037,2.82870203 150.393037,0.161102032 C94.8390368,-2.50649797 64.2930368,28.305002 34.5157368,66.540202 C4.7387368,104.776202 -10.5940632,137.453202 8.2942368,185.248202 C27.1825368,233.042202 68.3470368,222.204202 85.5060368,217.124202 C129.061037,204.231202 145.616037,187.908202 166.830037,209.129202 C187.400037,229.707202 218.841037,227.815202 250.168037,199.118202 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0375FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M160.777037,171.775202 L81.5920368,171.775202 L81.5920368,46.775202 L122.218037,46.775202 C122.218037,39.871802 127.814037,34.275202 134.718037,34.275202 C141.621037,34.275202 147.218037,39.871802 147.218037,46.775202 L187.842037,46.775202 L187.842037,130.213202 M164.405037,48.337702 L164.405037,62.400202 L105.030037,62.400202 L105.030037,48.337702"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0375FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M165.968037,59.275202 L175.342037,59.275202 L175.342037,133.136202 M158.162037,159.275202 L94.0920368,159.275202 L94.0920368,59.275202 L103.468037,59.275202"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.717,
    x2: 134.719,
    y1: 46.775,
    y2: 46.775,
    stroke: "#0375FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0375FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M187.842037,188.025202 C203.376037,188.025202 215.968037,175.433202 215.968037,159.900202 C215.968037,144.367202 203.376037,131.775202 187.842037,131.775202 C172.309037,131.775202 159.718037,144.367202 159.718037,159.900202 C159.718037,175.433202 172.309037,188.025202 187.842037,188.025202 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0375FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    points: "127.686 73.338 141.749 73.338 141.749 87.4 155.811 87.4 155.811 101.462 141.749 101.462 141.749 115.525 127.686 115.525 127.686 101.462 113.624 101.462 113.624 87.4 127.686 87.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0375FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M136.280037,129.588202 L158.509037,129.588202 M148.902037,143.650202 L136.280037,143.650202"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0375FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    points: "122.218 129.588 108.155 129.588 108.155 143.65 122.218 143.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#0375FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    points: "199.561 152.088 183.936 167.712 176.124 159.9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSend);
export default __webpack_public_path__ + "static/media/img-send.62f9eb9ce21701bcf5d7e37b21909d28.svg";
export { ForwardRef as ReactComponent };